export const PUBLIC_AUTHOR_FIELDS =
  'id, name, first_name, avatar_url, created_at, color';
const PUBLIC_NOTIFICATION_ACTOR_FIELDS = 'id, name, first_name, avatar_url';

export const RECIPE_WITH_PUBLIC_AUTHOR_SELECT =
  `*, authors:authors!recipes_author_id_fkey(${PUBLIC_AUTHOR_FIELDS}), tags(*)`;

export const COMMENT_WITH_AUTHOR_SELECT =
  `*, author:authors(${PUBLIC_AUTHOR_FIELDS})`;

export const REALIZATION_WITH_AUTHOR_SELECT =
  `id, recipe_id, author_id, comment, image, created_at, updated_at, author:authors(${PUBLIC_AUTHOR_FIELDS})`;

export const IN_APP_NOTIFICATION_WITH_ACTOR_SELECT =
  `id, event_type, recipe_id, comment_id, realization_id, title, body, route_path, is_read, read_at, created_at, actor:authors!in_app_notifications_actor_id_fkey(${PUBLIC_NOTIFICATION_ACTOR_FIELDS})`;
